import { formatGetHeaders } from '@configurations/api-configuration';
import { PriceCardDataGateway } from '@price-card/gateways/price-card-data.gateway';
import { PriceCardData } from '@price-card/models/price-card-data.model';
import { PriceCardListItem } from '@price-card/models/price-card-list-item.model';
import { environment } from '../../../../../environments/environment';

export class ApiPriceCardDataGateway implements PriceCardDataGateway {
  private readonly apiUrl = `${environment.backend_url}/api/v1/price-card`;

  async list(
    priceZoneId: number,
    technologyId: number,
    commercialOperationDateIds: number[],
  ): Promise<PriceCardListItem[]> {
    const params = new URLSearchParams({
      priceZoneId: String(priceZoneId),
      technologyId: String(technologyId),
      commercialOperationDateIds: commercialOperationDateIds.join(','),
    });
    const response = await fetch(`${this.apiUrl}/list?${params}`, await formatGetHeaders());
    if (!response.ok) {
      throw new Error('Error retrieving price card list: ' + response.statusText);
    }
    return response.json() as Promise<PriceCardListItem[]>;
  }

  async getData(priceCardIds: number[]): Promise<PriceCardData[]> {
    const params = new URLSearchParams({ priceCardIds: priceCardIds.join(',') });
    const response = await fetch(`${this.apiUrl}/data?${params}`, await formatGetHeaders());
    if (!response.ok) {
      throw new Error('Error retrieving price card data: ' + response.statusText);
    }
    return response.json() as Promise<PriceCardData[]>;
  }
}
